import { Fragment } from "react/jsx-runtime";

const DefaultLayout = ({ children }: any) => {
  return <Fragment>{children}</Fragment>;
};

export default DefaultLayout;
